import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * NavigationTab Component
 * 
 * Used for: Venue, Gallery, Upload navigation tabs
 * Consistent styling for all main navigation tabs
 */
const NavigationTab = ({ to, isActive, icon, children, onClick, shouldStack = true }) => {
  // Only stack if shouldStack is true AND screen is small enough
  const flexDirectionClass = shouldStack 
    ? 'flex-col xs:flex-row' 
    : 'flex-row'; // Always horizontal if 2 or fewer tabs
  
  const gapClass = shouldStack 
    ? 'gap-0.5 xs:gap-1' 
    : 'gap-1'; // Consistent gap when not stacking
  
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`relative px-2 sm:px-2.5 py-1.5 rounded-lg transition-all duration-200 text-sm font-medium focus:outline-none flex-shrink-0 min-h-[36px] flex ${flexDirectionClass} items-center justify-center ${gapClass}
        ${isActive
          ? 'shadow-md'
          : 'text-secondary hover:text-primary'}`}
      style={isActive ? {
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-surface)',
      } : {}}
      role="tab"
      aria-selected={isActive}
      aria-label={typeof children === 'string' ? children : undefined}
      title={typeof children === 'string' ? children : undefined}
    >
      {icon}
      <span className="whitespace-nowrap">{children}</span>
    </Link>
  );
};

NavigationTab.propTypes = {
  to: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  shouldStack: PropTypes.bool,
};

export default NavigationTab;
